import { getScale, getTopValue } from "../DialysisDragDrop.utils";

export function getStyle({ state, props }) {
  const scale = getScale(state);
  return {
    top: `${getTopValue(scale(props.value), state)}px`,
    opacity: props.opacity,
  };
}
